export const TEAMS_DATA_NAMESPACE = 'teams';